import {inject} from '@angular/core';
import {CanActivateFn, CanActivateChildFn, Router} from '@angular/router';
import {AuthRepository} from './auth.repository';

export const authGuard: CanActivateChildFn = () => {
    const auth = inject(AuthRepository);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        return true;
    }

    router.navigate(['/auth/login']);
    return false;
};

export const guestGuard: CanActivateFn = () => {
    const auth = inject(AuthRepository);
    const router = inject(Router);

    if (auth.isAuthenticated()) {
        router.navigateByUrl(auth.getLandingRouteByPermission());
        return false;
    }

    return true;
};
